import { NUXChecklistState } from "../../../hooks/useNUXChecklist";

export const isItemComplete = (state: NUXChecklistState) => {
  return state === NUXChecklistState.Finished;
};
